import {
  Button,
  EButtonColorVariant,
  EHeadingStyleVariant,
  ETextStyleVariant,
  Grid,
  GridItem,
  Heading,
  Text,
} from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import CamperVan from '@/assets/become-a-host/rv/camper-van.svg';
import Support from '@/assets/become-a-host/rv/support.svg';
import Terrain from '@/assets/become-a-host/rv/terrain.svg';

import styles from './BecomeAHost.module.css';
import { useHostingRVFlow } from './RV/useHostingRVFlow';

export const HostingOverview = () => {
  const intl = useIntl();

  const { redirectToHostingRVFlow, loading } = useHostingRVFlow();

  const handleHostingFlow = () => {
    redirectToHostingRVFlow();
  };

  const contentData = {
    subTitle: intl.formatMessage({ defaultMessage: 'Let’s do it together', id: 'jNJm0D' }),
    title: intl.formatMessage({
      defaultMessage: 'We build the tools and bring the guests.',
      id: 'DvR8mw',
    }),
    description: intl.formatMessage({
      defaultMessage: 'You host their outdoor adventures.',
      id: 'swZ1Dz',
    }),
    infoItems: [
      {
        icon: <CamperVan width={67} height={67} />,
        title: <FormattedMessage defaultMessage="Get started, fast" id="5897Xt" />,
        description: (
          <FormattedMessage
            defaultMessage="It doesn’t cost a thing to create your listing. You call the shots on pricing, rules, and more."
            id="KSwbTu"
          />
        ),
      },
      {
        icon: <Terrain width={67} height={67} className="p-3" />,
        title: <FormattedMessage defaultMessage="Host at your own pace" id="6vTFR5" />,
        description: (
          <FormattedMessage
            defaultMessage="Host when you want, where you want. You get paid every time a guest starts their trip, with an 80 / 20 split."
            id="UogfiA"
          />
        ),
      },
      {
        icon: <Support width={67} height={67} />,
        title: <FormattedMessage defaultMessage="We’re always here" id="4zznrt" />,
        description: (
          <FormattedMessage
            defaultMessage="24 / 7 live support for you and your guests. Plus, an entire hosting community and all the wisdom that comes with it."
            id="g0hzvJ"
          />
        ),
      },
    ],
  };

  return (
    <section className={`${styles.spacing} text-center`}>
      <Text variant={ETextStyleVariant.LegalRegular} className="mb-4 uppercase">
        {contentData.subTitle}
      </Text>
      <Heading variant={EHeadingStyleVariant.H3}>{contentData.title}</Heading>
      <Heading variant={EHeadingStyleVariant.H3Alt} className="mb-20">
        {contentData.description}
      </Heading>

      <Grid spacing={6} className="m-0 mb-20">
        {contentData.infoItems.map((item, index) => (
          <GridItem sm={4} xs={12} key={index} className="flex flex-col items-center text-center">
            {item.icon}
            <Heading variant={EHeadingStyleVariant.H5} className="my-4">
              {item.title}
            </Heading>
            <Text variant={ETextStyleVariant.MediumRegular} className="max-w-[320px]">
              {item.description}
            </Text>
          </GridItem>
        ))}
      </Grid>
      <Button
        onClick={handleHostingFlow}
        variant={EButtonColorVariant.Primary}
        label={intl.formatMessage({ defaultMessage: 'List your fleet', id: 'kMx06+' })}
        loading={loading}
      />
    </section>
  );
};
